export default __webpack_public_path__ + "static/media/pic9.32cf3bc2.png";